import React from 'react';
import { FormControl, Select } from '@contentful/f36-components';

export interface LocaleOption {
  code: string;
  name: string;
}

interface LocaleSelectorProps {
  locales: LocaleOption[];
  selectedLocale: string;
  onChangeLocale: (locale: string) => void;
}

const toFlagEmoji = (localeCode: string): string => {
  const parts = localeCode.split('-');
  const countryCode = parts.length > 1 ? parts[parts.length - 1] : '';
  if (countryCode.length !== 2) return '';
  return countryCode.toUpperCase().replace(/./g, (c) => String.fromCodePoint(0x1f1e6 - 65 + c.charCodeAt(0)));
};

export const LocaleSelector = ({ locales, selectedLocale, onChangeLocale }: LocaleSelectorProps): React.JSX.Element => {
  return (
    <FormControl>
      <FormControl.Label>Preview locale</FormControl.Label>
      <Select
        id="locale-selector"
        name="locale-selector"
        value={selectedLocale}
        onChange={(e: React.ChangeEvent<HTMLSelectElement>) => onChangeLocale(e.target.value)}
      >
        {locales.map(({ code, name }) => (
          <Select.Option key={code} value={code}>
            {toFlagEmoji(code)} {name}
          </Select.Option>
        ))}
      </Select>
    </FormControl>
  );
};
